import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import CareerCounselingJobPlacementDetails from '../../subdepartmentdetails/CareerCounselingJobPlacement'


function CareerCounselingJobPlacement() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Career Counseling and Job Placement Services || Employment and Workforce Development";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Employment Workforce"
            title="Career Counseling Job Placement"
            subtitledown="Department of Employment & Workforce Development"
           />
            <CareerCounselingJobPlacementDetails/>
        </div>
    </>
  )
}

export default CareerCounselingJobPlacement